import { render, staticRenderFns } from "./Bannerdetail.vue?vue&type=template&id=ea2fee26&scoped=true&"
import script from "./Bannerdetail.vue?vue&type=script&lang=js&"
export * from "./Bannerdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2fee26",
  null
  
)

export default component.exports